import React, { useEffect, useRef } from 'react';
import './Hero.css';

function Hero() {
  const headlineRef = useRef(null);
  const spineRef = useRef(null);
  const statsRef = useRef(null);

  useEffect(() => {
    const els = [spineRef.current, headlineRef.current, statsRef.current];
    els.forEach((el, i) => {
      if (!el) return;
      setTimeout(() => {
        el.classList.add('visible');
      }, i * 200);
    });
  }, []);

  return (
    <section id="work" className="hero">
      <div className="hero-spine">
        <div ref={spineRef} className="hero-spine-text">
          Shahd Abubaker &nbsp;&nbsp; DevOps &amp; SRE &nbsp;&nbsp; Amman Jordan
        </div>
      </div>

      <div className="hero-main">
        <div className="hero-content">
          <div className="hero-top">
            <div className="hero-eyebrow">
              Site Reliability Engineer at SITA Aviation
            </div>

            <h1 ref={headlineRef} className="hero-headline">
              Building the infra<br />
              <span className="muted">the world</span>
              <span className="accent"> flies on.</span>
            </h1>

            <div className="hero-pill">
              <span className="hero-pill-dot" />
              <span className="hero-pill-text">Open to consulting</span>
            </div>

            <p className="hero-desc">
              From localhost to keeping airports, airlines and borders running.
              Nine years of turning slow, manual operations into fast, automated
              platforms across AWS, Azure and GCP.
            </p>
          </div>

          <div className="hero-actions">
            <a href="#work" className="btn-primary">View my work</a>
            <a href="#contact" className="btn-secondary">Work with me</a>
          </div>
        </div>

        <div ref={statsRef} className="hero-stats">
          <div className="stat">
            <div className="stat-num">9+</div>
            <div className="stat-label">Years</div>
          </div>
          <div className="stat-divider" />
          <div className="stat">
            <div className="stat-num">3</div>
            <div className="stat-label">Clouds</div>
          </div>
          <div className="stat-divider" />
          <div className="stat">
            <div className="stat-num">CNCF</div>
            <div className="stat-label">Organizer</div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Hero;
